import { FaArrowRight } from "react-icons/fa";
import { FaSpinner } from "react-icons/fa";

const CustomButton = ({
  text,
  onClick,
  icon,
  type = "button",
  className = "",
  disabled,
  isLoading
}) => {
  const isDisabled = disabled || isLoading;

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={isDisabled}
      className={`mt-10 relative flex items-center justify-center gap-2 px-4 py-2 rounded-lg bg-[#203E6F] text-white font-semibold hover:bg-[#1a3259] transition duration-200 disabled:cursor-not-allowed ${className}`}
    >
      {isDisabled && (
        <div className="absolute inset-0 bg-white bg-opacity-20 rounded-lg z-10" />
      )}

      <div className={`flex items-center gap-2 z-20 ${isLoading ? "opacity-50" : ""}`}>
        {isLoading ? (
          <FaSpinner className="animate-spin" />
        ) : (
          <>
            {icon && <span>{icon}</span>}
            <span>{text}</span>
          </>
        )}
      </div>
    </button>
  );
};

export default CustomButton;
